<div class="toasts">
  @for (toast of toasts; track toast) {
    <div [@toast] [ngClass]="{ good: toast.isGood, toast: !toast.component }">
      @if (toast.component) {
        <div>
          <ng-container *ngComponentOutlet="toast.component.comp; inputs: toast.component.inputs"></ng-container>
        </div>
      } @else {
        @if (!toast.hideIcon) {
          <lib-svg
            [svg]="toast.isGood ? 'fontawesome/check-circle' : 'times-circle'"
            [ngClass]="{ '[&_svg]:fill-[--color-text-button]': toast.isGood, '[&_svg]:fill-white': !toast.isGood }"
            class="icon"
          ></lib-svg>
        }
        <span
          data-source="prismic"
          [innerHTML]="toast.message"
          class="p-with-margin"
          [ngClass]="{ 'text-[--color-text-button]': toast.isGood, 'text-white': !toast.isGood }"
        ></span>
      }
    </div>
  }
</div>
